import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import Toast from '../../../../core/components/core/Util/Toast/Toast';
import { getUserSession } from "../../../../core/util/core/Session";
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';
import { useDispatch } from 'react-redux';
import { useKeysStore } from '../../../../core/store/useKeysStore';

function List() {
     const { keys } = useKeysStore();
    const dispatch = useDispatch();
    const session = getUserSession();

     const profileFilter = chooseProfileFilter();

     const isBiManager = session.user.application_profile_id == keys?.default_foreign_key?.pdc_profiles.bi_manager
     const isBusinessManager = session.user.application_profile_id == keys?.default_foreign_key?.pdc_profiles?.business_manager
     const isProjectManager = session.user.application_profile_id == keys?.default_foreign_key?.pdc_profiles?.project_manager

    const pathFrontEnd = '/demonstratives/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllDemonstrativeTypes: config.endpoints.backend + 'demonstrativetypes/getall',
        endpointGetAllDemonstrativePeriods: config.endpoints.backend + 'demonstrativeperiods/getall',
        endpointDelete: `${config.endpoints.backend}demonstratives/delete`,
        endpointUpdatedBiDemonstrative: `${config.endpoints.backend}demonstratives/updatedBiDemonstrative`,
        endpoint: config.endpoints.backend + 'demonstratives/getall'
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            !profileFilter.pdc_entity_id && !isProjectManager ? {
                name: 'pdc_entity_id',
                type: 'select',
                label: 'Entidade',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllEntities,
                    label: 'corporate_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            } : {},
            !isProjectManager ? {
                name: 'pdc_project_id',
                type: 'select',
                label: 'Projeto',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllProjects,
                    label: 'project_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            } : {},
            {
                name: 'pdc_demonstrative_type_id',
                type: 'select',
                label: 'Tipo de Demonstrativo',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllDemonstrativeTypes,
                    label: 'name',
                    value: 'id',
                    params: {
                        filter: {
                            assistance: isBiManager
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            {
                name: 'pdc_demonstrative_period_id',
                type: 'select',
                label: 'Período de Demonstrativo',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllDemonstrativePeriods,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'year',
                type: 'year',
                selectable: true,
                label: 'Ano',
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            },
        ]
    }

    let list = {
        labelTitle: 'Lista de Demonstrativos',
        labelTitleButtonAdd: 'Incluir novo demonstrativo',
        fieldsShowOnDelete: ['name'],
        showPrintButtons: true,
        canDownload: true,
        fieldToDownload: 'file',
        formFilters: filters,
        filter: {
            ...profileFilter,
            assistance: isBiManager
        },
        columns: [
            {
                name: 'project',
                label: 'Projeto',
                width: "20%"
            },
            {
                name: 'demonstrative_type',
                label: 'Tipo de Demonstrativo',
                width: "25%"
            },
            {
                name: 'demonstrative_period',
                label: 'Período de Demonstrativo'
            },
            {
                name: 'reference',
                label: 'Referência',
                width: "15%"
            },
            {
                name: 'obs',
                label: 'Descrição'
            },
            {
                name: 'created_at',
                label: 'Data de Criação'
            },
            isBiManager || isBusinessManager ? {
                name: 'update_bi',
                label: 'Atualizado no BI',
                width: "15%"
            } : {
                width: '0%'
            },
            isBiManager || isBusinessManager ? {
                name: 'update_bi_date',
                label: 'Ultima Atualização',
                width: "15%"
            } : {
                width: "0%"
            }
        ]
    };

    if (isBiManager || isBusinessManager) {
        list = {
            ...list,
            canAdd: isBiManager ? false : true,
            canEdit: isBiManager ? false : true,
            canDelete: isBiManager ? false : true,
            columnsButtons: [
                {
                    title: 'Atualizar BI',
                    style: { width: '1%' },
                    buttons: [
                        {
                            label: 'Atualizar BI',
                            onClick: async item => {
                                await Fetch.put(paths.endpointUpdatedBiDemonstrative, { id: item.id });

                                dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });

                                Toast.success("Demonstrativo atualizado!");
                            }
                        }
                    ]
                }
            ]
        }
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                {...(typeof list.canAdd !== 'undefined' ? { canAdd: list.canAdd } : {})}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
